import { render, staticRenderFns } from "./MainProject.vue?vue&type=template&id=1838d571&scoped=true&"
import script from "./MainProject.vue?vue&type=script&lang=js&"
export * from "./MainProject.vue?vue&type=script&lang=js&"
import style0 from "./MainProject.vue?vue&type=style&index=0&id=1838d571&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1838d571",
  null
  
)

export default component.exports